import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/foods-drinks";
const FoodDrinkApi = {
  foodDrink(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  createFoodDrink(params: any) {
    return api.post(path, params);
  },

  updateFoodDrink(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteFoodDrink(id: any) {
    return api.delete(`${path}/${id}`);
  },

  updateStatusFoodDrink(params: any) {
    return api.patch(`${path}/update-status`, params);
  },

  deleteMultipleFoodDrink(params: any) {
    return api.delete(`${path}/bulk-delete`, params);
  },

  updateSearchKeywordFoodDrink(params: any) {
    return api.post(`${path}/update-search-keywords-id`, params);
  },
};

export function uploadFiles(files: any) {
  const url = "/assets/direct";
  return api.post(url, files, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export default FoodDrinkApi;
